import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {DebtEmployee} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import { union, difference } from 'lodash';
import {listDebtPartner, receiptPartner} from "@/modules/receiptsexpenses/receiptpartner/services";
import {ReceiptPartnerState} from "@/interfaces/state/receiptepartner";
import {ReceiptPartnerParams} from "@/modules/receiptsexpenses/receiptpartner/params";
import {ReceiptPickingListStore} from "@/modules/receiptsexpenses/receiptpickinglist/store";

@Module({ dynamic: true, name: "receiptPartnerStore", store })
class ReceiptPartnerModule extends VuexModule implements ReceiptPartnerState {
    data: IdMapper<DebtEmployee> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ReceiptPartnerParams = new ReceiptPartnerParams();

    @Mutation
    private MAP_DEBT_PARTNER(payload: any) {
        const idMapper: IdMapper<DebtEmployee> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((debt: DebtEmployee, index: number) => {
            idMapper[debt.id] = {...debt, stt: index + 1};
            return debt.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_DEBT_PARTNER(payload: any) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private UPDATE_PARAMS_DEBT_PARTNER(payload: any) {
        this.params = payload;
    }

    @Mutation
    private REMOVE_DEBT_PARTNER_BY_IDS(payload: number[]) {
        this.ids = this.ids.filter((id: number) => !payload.includes(id));
        payload.forEach((id: number) => delete this.data[id]);
    }

    @Mutation
    private CLEAR_DEBT_PARTNER_STORE() {
        this.ids = [];
        this.data = {};
    }

    @Action({ rawError: true })
    public async listDebtPartner(params: any) {
        const { data } = await listDebtPartner(params);
        this.MAP_DEBT_PARTNER(data);
        return data.datas;
    }

    @Action({ rawError: true })
    public updateParamsDebtPartner(payload: any) {
        this.UPDATE_PARAMS_DEBT_PARTNER(payload);
    }

    @Action({ rawError: true })
    public async receiptPartner(dataReq: any) {
        const { data } = await receiptPartner(dataReq);
        ReceiptPickingListStore.setReceiptPickingList(data.data);
        return data.data;
    }

    @Action({ rawError: true })
    public clearDebtPartnerStore() {
        this.CLEAR_DEBT_PARTNER_STORE();
    }

    @Action({ rawError: true })
    public deleteDebtPartnerByIds(payload: any) {
        this.REMOVE_DEBT_PARTNER_BY_IDS(payload);
    }
}

export const ReceiptPartnerStore = getModule(ReceiptPartnerModule);